import { useQuery } from "@tanstack/react-query";
import { fetchStorefrontConfig } from "../api/storefront";

export const useStorefront = (identifier: string | undefined) => {
  return useQuery({
    queryKey: ["storefront", identifier],
    queryFn: () => {
      if (!identifier) {
        throw new Error("Missing storefront identifier.");
      }
      return fetchStorefrontConfig(identifier);
    },
    enabled: Boolean(identifier),
    staleTime: 60_000,
  });
};
